
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path-1",attrs:{"fill":"#000","d":"M12 9a5 5 0 100 10 5 5 0 000-10zm0 9.26a4.21 4.21 0 11.02-8.43 4.21 4.21 0 01-.02 8.43zm2.28-4.63h-1.93v-2.7a.33.33 0 00-.35-.37.33.33 0 00-.37.37V14c0 .24.13.35.37.35h2.3a.31.31 0 00.35-.35c.05-.26-.13-.37-.37-.37z"}}),_c('path',{staticClass:"path-2",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M7.2 5.99A1.19 1.19 0 106 4.8a1.15 1.15 0 001.2 1.19zm0-1.63c.25 0 .36.13.36.38a.34.34 0 01-.36.39.38.38 0 010-.77zm9.58 1.63A1.19 1.19 0 1015.6 4.8a1.15 1.15 0 001.18 1.19zm0-1.63c.25 0 .37.13.37.38a.34.34 0 01-.37.39c-.25 0-.36-.14-.36-.39s.11-.38.36-.38zM20.33 2H3.63A1.63 1.63 0 002 3.63v16.76A1.6 1.6 0 003.63 22h16.76A1.6 1.6 0 0022 20.39V3.6A1.63 1.63 0 0020.33 2zm-16.7.8h16.76a.82.82 0 01.8.81V6.8H2.82V3.61a.75.75 0 01.81-.8zm16.7 18.34H3.63a.81.81 0 01-.8-.8V7.6h18.33v12.77a.77.77 0 01-.83.77z","clip-rule":"evenodd"}})])
          )
        }
      }
    